"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
var __spreadArray = this && this.__spreadArray || function (to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
    if (ar || !(i in from)) {
      if (!ar) ar = Array.prototype.slice.call(from, 0, i);
      ar[i] = from[i];
    }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Form = exports.FormDefaultProps = exports.handlers = void 0;
var React = __importStar(require("react")); // tslint:disable-line
var react_1 = require("react");
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var immer_1 = __importDefault(require("immer"));
var lodash_1 = require("lodash");
var button_1 = require("../elements/button");
var icon_1 = require("../elements/icon");
var field_container_1 = require("../elements/field-container");
var loader_1 = require("../elements/loader");
var loading_layout_1 = require("../elements/loading-layout");
var field_set_1 = require("./field-set");
var field_1 = require("./field");
var form_header_1 = require("./form-header");
var form_controls_1 = require("./form-controls");
var submit_mutation_input_1 = require("../../utils/submit-mutation-input");
var use_lang_1 = require("../../hooks/use-lang");
var form_field_values_1 = require("../../utils/form-field-values");
var use_entity_definition_named_1 = require("../../hooks/use-entity-definition-named");
var use_app_layout_1 = require("../../hooks/use-app-layout");
var error_message_1 = require("../elements/error-message");
var sprintf_js_1 = require("sprintf-js");
var html_1 = require("../elements/html");
var global_style_1 = require("../elements/global-style");
var client_1 = require("@apollo/client");
var form_state_context_1 = require("../context/form-state-context");
var use_form_1 = require("../../hooks/use-form");
var current_user_can_1 = require("../../utils/current-user-can");
var encode = function (items) {
  return (0, lodash_1.map)(items, function (_a) {
    var name = _a.name,
      value = _a.value;
    var stringValue = (0, lodash_1.isFunction)(value) ? value() : value;
    return "".concat(encodeURIComponent(name), "=").concat(encodeURIComponent(stringValue));
  }).join("&");
};
exports.handlers = {
  netlify: function (_a) {
    return __awaiter(void 0, [_a], void 0, function (_b) {
      var body, result;
      var fieldValues = _b.fieldValues,
        name = _b.name,
        action = _b.action;
      return __generator(this, function (_c) {
        switch (_c.label) {
          case 0:
            body = encode(__spreadArray([{
              name: "form-name",
              value: name
            }], __read((0, lodash_1.map)(fieldValues, function (value, name) {
              return {
                name: name,
                value: value
              };
            })), false));
            return [4 /*yield*/, fetch("/", {
              method: "POST",
              headers: {
                "Content-Type": "application/x-www-form-urlencoded"
              },
              body: body
            })];
          case 1:
            result = _c.sent();
            action(fieldValues, result);
            return [2 /*return*/];
        }
      });
    });
  }
};
var filterUnknown = function (fieldState, fieldDictionary) {
  var names = (0, lodash_1.keys)(fieldDictionary);
  return (0, lodash_1.pickBy)(fieldState, function (state, fieldName) {
    return names.indexOf(fieldName) !== -1;
  });
};
var validate = function (fieldState, fields, fieldHasValue, include) {
  if (include === void 0) {
    include = function (field) {
      return true;
    };
  }
  return (0, immer_1.default)(fieldState, function (draft) {
    var first = false;
    var focus = function (state) {
      if (!first) {
        first = true;
        state.focus = true;
      }
    };
    (0, lodash_1.each)(fields, function (field, name) {
      draft[name] = (0, immer_1.default)(draft[name] || {}, function (state) {
        state.valid = true;
        state.focus = false;
        state.reason = null;
        state.errorMessage = '';
        // transform the value in state to the actual value
        if ((0, lodash_1.isFunction)(state.value)) {
          state.value = state.value();
        }
        state.defaultValue = state.value;
        if (include(field)) {
          if (!fieldHasValue(field, state) && field.required) {
            focus(state);
            state.valid = false;
            state.reason = 'empty';
            state.metadata = __assign(__assign({}, state.metadata || {}), {
              label: field.label
            });
            state.errorMessage = field.messages && field.messages.required || 'This field is required';
          } else {
            if (field.validate && !field.validate({
              fieldState: state,
              fieldStates: fieldState,
              field: field,
              fields: fields
            })) {
              focus(state);
              state.valid = false;
              state.reason = 'invalid';
              state.metadata = __assign(__assign({}, state.metadata || {}), {
                label: field.label
              });
              state.errorMessage = field.messages && field.messages.valid || 'Please provide a VALID value for this field';
            }
          }
        }
      });
    });
  });
};
;
exports.FormDefaultProps = {
  fieldSets: [{
    name: "overview"
  }],
  fieldState: {},
  fields: [],
  icon: function () {
    return null;
  },
  netlify: false,
  name: 'contact',
  index: 0,
  bufferAtEnd: 500,
  isModal: false,
  loading: false,
  disabled: false,
  paginate: false,
  label: '',
  isCreate: false,
  page: 0,
  showStripes: false,
  action: function (props, result) {},
  labelRenderer: field_container_1.defaultLabelRenderer,
  preventDefault: true,
  honeypotName: "ph1",
  fieldHasValue: function (field, state) {
    return (0, lodash_1.isArray)(state.value) ? !!state.value.length : state.value && state.value.trim && state.value.trim() !== '';
  },
  onSubmit: function (props) {},
  onCancel: function () {},
  onChange: function (fieldValues) {},
  onPreviousPage: function () {},
  onNextPage: function () {},
  onChangePage: function (page) {}
};
// -------- Styles ----------->
var FormStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    padding: 0;\n    width: 100%;\n    ", "\n  "], ["\n    display: flex;\n    padding: 0;\n    width: 100%;\n    ", "\n  "])), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      height: 100%;\n      margin-bottom: 0;\n    "], ["\n      height: 100%;\n      margin-bottom: 0;\n    "])));
  })
});
var ButtonStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    margin-top: ", ";\n  "], ["\n    margin-top: ", ";\n  "])), theme_1.theme.UNIT(6))
});
var IconStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    ", ";\n    width: 12px;\n    height: 12px;\n    margin-left: ", ";\n  "], ["\n    ", ";\n    width: 12px;\n    height: 12px;\n    margin-left: ", ";\n  "])), theme_1.theme.FILL('dark'), theme_1.theme.UNIT(1))
});
var HoneypotStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: none;\n  "], ["\n    display: none;\n  "])))
});
var LoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    margin-left: -14px;\n  "], ["\n    margin-left: -14px;\n  "])))
});
var FieldSetsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n      \n  "], ["\n      \n  "])))
});
var ErrorMessageStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    margin: 0;\n    width: 100%;\n    font-weight: 500;\n    font-size: ", ";\n    border-bottom: 1px solid ", ";\n    padding: ", ";\n\n    b {\n      color: ", ";\n    }\n  "], ["\n    margin: 0;\n    width: 100%;\n    font-weight: 500;\n    font-size: ", ";\n    border-bottom: 1px solid ", ";\n    padding: ", ";\n\n    b {\n      color: ", ";\n    }\n  "])), theme_1.theme.FONT_SIZE(14), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(4), theme_1.theme.COLOR('error')),
  tablet: (0, styled_components_1.css)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(15)),
  desktop: (0, styled_components_1.css)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(16))
});
var LoadingLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n  "], ["\n    box-sizing: border-box;\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return !props.isModal && (0, styled_components_1.css)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n      height: 80%;\n      width: 100%;\n      min-height: 200px;\n\n    "], ["\n      height: 80%;\n      width: 100%;\n      min-height: 200px;\n\n    "])));
  }, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n      height: 80%;\n      min-height: 200px;\n    "], ["\n      height: 80%;\n      min-height: 200px;\n    "])));
  })
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n    flex-grow: 0;\n    flex-shrink: 0;\n    position: fixed;\n    top: 0;\n\n    ", "\n\n    ", "\n  "], ["\n    flex-grow: 0;\n    flex-shrink: 0;\n    position: fixed;\n    top: 0;\n\n    ", "\n\n    ", "\n  "])), function (props) {
    return !props.isModal && (0, styled_components_1.css)(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), props._width);
  }, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      position: static;\n    "], ["\n      position: static;\n    "])));
  })
});
var DummyHeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n    ", ";\n    position: static;\n    visibility: hidden;\n\n    ", "\n  "], ["\n    ", ";\n    position: static;\n    visibility: hidden;\n\n    ", "\n  "])), HeaderStyles, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
  })
});
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n    font-family: ", ";\n    min-width: 320px;\n    position: relative;\n    margin: 0 auto;\n\n    ", "\n  "], ["\n    font-family: ", ";\n    min-width: 320px;\n    position: relative;\n    margin: 0 auto;\n\n    ", "\n  "])), theme_1.theme.FONT('sans'), function (props) {
    return !props.isModal && (0, styled_components_1.css)(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      width: 100%;\n    "], ["\n      width: 100%;\n    "])));
  })
});
var BodyContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n    background: #FFF;\n    box-sizing: border-box;\n\n    overflow: hidden;\n    ", "\n\n    ", "\n  "], ["\n    background: #FFF;\n    box-sizing: border-box;\n\n    overflow: hidden;\n    ", "\n\n    ", "\n  "])), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n      overflow-y: auto;\n      max-height: calc(90vh - 100px);\n    "], ["\n      overflow-y: auto;\n      max-height: calc(90vh - 100px);\n    "])));
  }, function (props) {
    return props.isModal && props.fillModal && (0, styled_components_1.css)(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n      height: calc(85vh - 100px);\n    "], ["\n      height: calc(85vh - 100px);\n    "])));
  })
});
var BodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n    background: #FFF;\n    box-sizing: border-box;\n    flex-grow: 1;\n    \n    ", "\n\n    ", "\n    \n    ", "\n  "], ["\n    background: #FFF;\n    box-sizing: border-box;\n    flex-grow: 1;\n    \n    ", "\n\n    ", "\n    \n    ", "\n  "])), function (props) {
    return props.lockScroll && (0, styled_components_1.css)(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n      overflow-y: hidden;\n    "], ["\n      overflow-y: hidden;\n    "])));
  }, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      // max-height: calc(80vh - 100px);\n    "], ["\n      // max-height: calc(80vh - 100px);\n    "])));
  }, function (_a) {
    var _loading = _a._loading;
    return !_loading && (0, styled_components_1.css)(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(3));
  }),
  tablet: (0, styled_components_1.css)(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n  "])), function (_a) {
    var _loading = _a._loading;
    return !_loading && (0, styled_components_1.css)(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(5));
  }, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4.5));
  }),
  desktop: (0, styled_components_1.css)(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n    ", "\n\n    ", "\n  "], ["\n    ", "\n\n    ", "\n  "])), function (_a) {
    var _loading = _a._loading;
    return !_loading && (0, styled_components_1.css)(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      padding: ", ";\n    "], ["\n      padding: ", ";\n    "])), theme_1.theme.UNIT(6));
  }, function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n      padding: ", " ", ";\n    "], ["\n      padding: ", " ", ";\n    "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(4));
  })
});
var BodyLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n    margin: 0 auto;\n  "], ["\n    margin: 0 auto;\n  "])))
});
var BodyConstrainStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n    ", "\n\n    ", "\n\n  "], ["\n    ", "\n\n    ", "\n\n  "])), function (props) {
    return props.maxWidth && (0, styled_components_1.css)(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n      max-width: ", "px;\n    "], ["\n      max-width: ", "px;\n    "])), props.maxWidth);
  }, function (props) {
    return props.bufferAtEnd && (0, styled_components_1.css)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n      padding-bottom: ", "px;\n    "], ["\n      padding-bottom: ", "px;\n    "])), props.bufferAtEnd);
  })
});
var FooterStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n    background: ", ";\n    border-top: 1px solid ", ";\n    position: relative;\n    flex-grow: 0;\n    flex-shrink: 0;\n    padding: 0;\n\n    ", "\n\n    ", "\n  "], ["\n    background: ", ";\n    border-top: 1px solid ", ";\n    position: relative;\n    flex-grow: 0;\n    flex-shrink: 0;\n    padding: 0;\n\n    ", "\n\n    ", "\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.COLOR('line-subtle'), function (props) {
    return !props.isModal && (0, styled_components_1.css)(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n      position: fixed;\n      bottom: 0;\n      width: ", "px;\n    "], ["\n      position: fixed;\n      bottom: 0;\n      width: ", "px;\n    "])), props._width);
  }, function (_a) {
    var hasError = _a.hasError;
    return hasError && (0, styled_components_1.css)(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n      border-top-color: #FFF5E0;\n    "], ["\n      border-top-color: #FFF5E0;\n    "])));
  })
});
var FADE_HEIGHT = 40;
var FooterFadeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n    display: flex;\n    box-sizing: border-box;\n    width: calc(100% - 15px);\n    position: absolute;\n    z-index: 45;\n    top: -", "px;\n    height: ", "px;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1.0) 100%);\n  "], ["\n    display: flex;\n    box-sizing: border-box;\n    width: calc(100% - 15px);\n    position: absolute;\n    z-index: 45;\n    top: -", "px;\n    height: ", "px;\n    background: linear-gradient(to bottom, rgba(255, 255, 255, 0) 0%, rgba(255, 255, 255, 1.0) 100%);\n  "])), FADE_HEIGHT + 1, FADE_HEIGHT),
  tablet: (0, styled_components_1.css)(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n\n  "], ["\n\n  "]))),
  desktop: (0, styled_components_1.css)(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n\n  "], ["\n\n  "])))
});
var StripeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n    height: 3px;\n    z-index: 46;\n    width: 100%;\n    transition: all 0.3s;\n    opacity: 0;\n    background: repeating-linear-gradient(\n      -45deg,\n      ", ",\n      ", " 3px,\n      #FAFAFA 3px,\n      #FAFAFA 6px\n    );\n\n    ", "\n  "], ["\n    height: 3px;\n    z-index: 46;\n    width: 100%;\n    transition: all 0.3s;\n    opacity: 0;\n    background: repeating-linear-gradient(\n      -45deg,\n      ", ",\n      ", " 3px,\n      #FAFAFA 3px,\n      #FAFAFA 6px\n    );\n\n    ", "\n  "])), theme_1.theme.COLOR('primary'), theme_1.theme.COLOR('primary'), function (props) {
    return props.showStripes && (0, styled_components_1.css)(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n      opacity: 1.0;\n    "], ["\n      opacity: 1.0;\n    "])));
  })
});
var FooterStripesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    top: -3px;\n  "], ["\n    ", ";\n    position: absolute;\n    top: -3px;\n  "])), StripeStyles)
});
var HeaderStripesStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n    ", ";\n    position: absolute;\n    top: 0px;\n  "], ["\n    ", ";\n    position: absolute;\n    top: 0px;\n  "])), StripeStyles)
});
var FooterLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n    margin: 0 auto;\n    box-sizing: content-box;\n    cursor: -webkit-grab;\n\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "], ["\n    margin: 0 auto;\n    box-sizing: content-box;\n    cursor: -webkit-grab;\n\n    &:active {\n      cursor: -webkit-grabbing;\n    }\n  "])))
});
var FooterBodyStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n    position: relative;\n    padding: ", " 0 ", ";\n    min-height: 26px;\n    overflow: visible;\n  "], ["\n    position: relative;\n    padding: ", " 0 ", ";\n    min-height: 26px;\n    overflow: visible;\n  "])), theme_1.theme.UNIT(2.5), theme_1.theme.UNIT(3)),
  tablet: (0, styled_components_1.css)(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n  "], ["\n    padding: ", " 0 ", ";\n  "])), theme_1.theme.UNIT(3.5), theme_1.theme.UNIT(4)),
  desktop: (0, styled_components_1.css)(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n    padding: ", " 0 ", ";\n  "], ["\n    padding: ", " 0 ", ";\n  "])), theme_1.theme.UNIT(4.5), theme_1.theme.UNIT(5))
});
var FormControlsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n    padding-bottom: 0;\n  "], ["\n    padding-bottom: 0;\n  "])))
});
var SubmittingOverlayStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n    height: 100vh;\n    position: fixed;\n    background: #F5F5F5EE;\n    width: 100%;\n    display: flex;\n    left: 0;\n    top: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 200;\n\n    ", "\n  "], ["\n    height: 100vh;\n    position: fixed;\n    background: #F5F5F5EE;\n    width: 100%;\n    display: flex;\n    left: 0;\n    top: 0;\n    align-items: center;\n    justify-content: center;\n    z-index: 200;\n\n    ", "\n  "])), function (props) {
    return props.isModal && (0, styled_components_1.css)(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n      max-height: 100%;\n      position: absolute;\n    "], ["\n      max-height: 100%;\n      position: absolute;\n    "])));
  })
});
var SubmittingLoaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n    font-size: ", ";\n  "], ["\n    font-size: ", ";\n  "])), theme_1.theme.FONT_SIZE(18))
});
var ErrorMessageContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n    background: #FFFBF3;\n    color: ", ";\n    padding-right: ", ";\n  "], ["\n    background: #FFFBF3;\n    color: ", ";\n    padding-right: ", ";\n  "])), theme_1.theme.COLOR('error'), theme_1.theme.UNIT(6))
});
// --------- Components --------->
var My = {
  Button: (0, styled_components_1.default)(button_1.Button)(templateObject_57 || (templateObject_57 = __makeTemplateObject(["", ""], ["", ""])), ButtonStyles),
  FieldSets: styled_components_1.default.div(templateObject_58 || (templateObject_58 = __makeTemplateObject(["", ""], ["", ""])), FieldSetsStyles),
  Form: styled_components_1.default.form(templateObject_59 || (templateObject_59 = __makeTemplateObject(["", ""], ["", ""])), FormStyles),
  Loader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_60 || (templateObject_60 = __makeTemplateObject(["", ""], ["", ""])), LoaderStyles),
  LoadingLayout: (0, styled_components_1.default)(loading_layout_1.LoadingLayout)(templateObject_61 || (templateObject_61 = __makeTemplateObject(["", ""], ["", ""])), LoadingLayoutStyles),
  HoneyPot: styled_components_1.default.input(templateObject_62 || (templateObject_62 = __makeTemplateObject(["", ""], ["", ""])), HoneypotStyles),
  Icon: (0, styled_components_1.default)(icon_1.Icon)(templateObject_63 || (templateObject_63 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  ErrorMessageContainer: styled_components_1.default.div(templateObject_64 || (templateObject_64 = __makeTemplateObject(["", ""], ["", ""])), ErrorMessageContainerStyles),
  ErrorMessage: (0, styled_components_1.default)(error_message_1.ErrorMessage)(templateObject_65 || (templateObject_65 = __makeTemplateObject(["", ""], ["", ""])), ErrorMessageStyles),
  FormControls: (0, styled_components_1.default)(form_controls_1.FormControls)(templateObject_66 || (templateObject_66 = __makeTemplateObject(["", ""], ["", ""])), FormControlsStyles),
  Container: styled_components_1.default.div(templateObject_67 || (templateObject_67 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: (0, styled_components_1.default)(form_header_1.FormHeader)(templateObject_68 || (templateObject_68 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  DummyHeader: (0, styled_components_1.default)(form_header_1.FormHeader)(templateObject_69 || (templateObject_69 = __makeTemplateObject(["", ""], ["", ""])), DummyHeaderStyles),
  BodyContainer: styled_components_1.default.div(templateObject_70 || (templateObject_70 = __makeTemplateObject(["", ""], ["", ""])), BodyContainerStyles),
  Body: styled_components_1.default.div(templateObject_71 || (templateObject_71 = __makeTemplateObject(["", ""], ["", ""])), BodyStyles),
  BodyLayout: styled_components_1.default.div(templateObject_72 || (templateObject_72 = __makeTemplateObject(["", ""], ["", ""])), BodyLayoutStyles),
  BodyConstrain: styled_components_1.default.div(templateObject_73 || (templateObject_73 = __makeTemplateObject(["", ""], ["", ""])), BodyConstrainStyles),
  Footer: styled_components_1.default.footer(templateObject_74 || (templateObject_74 = __makeTemplateObject(["", ""], ["", ""])), FooterStyles),
  FooterFade: styled_components_1.default.div(templateObject_75 || (templateObject_75 = __makeTemplateObject(["", ""], ["", ""])), FooterFadeStyles),
  FooterStripes: styled_components_1.default.div(templateObject_76 || (templateObject_76 = __makeTemplateObject(["", ""], ["", ""])), FooterStripesStyles),
  HeaderStripes: styled_components_1.default.div(templateObject_77 || (templateObject_77 = __makeTemplateObject(["", ""], ["", ""])), HeaderStripesStyles),
  FooterBody: styled_components_1.default.div(templateObject_78 || (templateObject_78 = __makeTemplateObject(["", ""], ["", ""])), FooterBodyStyles),
  FooterLayout: styled_components_1.default.div(templateObject_79 || (templateObject_79 = __makeTemplateObject(["", ""], ["", ""])), FooterLayoutStyles),
  SubmittingOverlay: styled_components_1.default.div(templateObject_80 || (templateObject_80 = __makeTemplateObject(["", ""], ["", ""])), SubmittingOverlayStyles),
  SubmittingLoader: (0, styled_components_1.default)(loader_1.Loader)(templateObject_81 || (templateObject_81 = __makeTemplateObject(["", ""], ["", ""])), SubmittingLoaderStyles)
};
exports.FormDefaultProps.fieldRenderer = field_1.Field;
exports.FormDefaultProps.fieldSetRenderer = field_set_1.FieldSet;
exports.FormDefaultProps.controlsRenderer = My.FormControls;
var ContextStyle = (0, styled_components_1.createGlobalStyle)(templateObject_82 || (templateObject_82 = __makeTemplateObject(["\n  body, html {\n    height: 100%;\n    background: #FFF;\n  }\n\n  #gatsby-focus-wrapper > div {\n    background: #FFF;\n  }\n\n"], ["\n  body, html {\n    height: 100%;\n    background: #FFF;\n  }\n\n  #gatsby-focus-wrapper > div {\n    background: #FFF;\n  }\n\n"])));
var Form = function (props) {
  var entityTypeName = props.entityTypeName,
    head = props.head,
    className = props.className,
    children = props.children,
    netlify = props.netlify,
    labelRenderer = props.labelRenderer,
    label = props.label,
    isCreate = props.isCreate,
    submitError = props.submitError,
    fieldRenderer = props.fieldRenderer,
    fieldSetRenderer = props.fieldSetRenderer,
    controlsRenderer = props.controlsRenderer,
    fieldHasValue = props.fieldHasValue,
    hasActiveModal = props.hasActiveModal,
    honeypotName = props.honeypotName,
    name = props.name,
    paginate = props.paginate,
    onPreviousPage = props.onPreviousPage,
    onNextPage = props.onNextPage,
    onChangePage = props.onChangePage,
    onCancel = props.onCancel,
    subLabel = props.subLabel,
    badge = props.badge,
    fieldSets = props.fieldSets,
    index = props.index,
    fieldState = props.fieldState,
    loading = props.loading,
    disabled = props.disabled,
    maxWidth = props.maxWidth,
    onChange = props.onChange,
    onNameBlur = props.onNameBlur,
    icon = props.icon,
    isModal = props.isModal,
    fillModal = props.fillModal,
    statusValue = props.statusValue,
    startControls = props.startControls,
    showStripes = props.showStripes,
    showDeleteButton = props.showDeleteButton,
    onDelete = props.onDelete,
    labelElement = props.labelElement;
  var t = (0, use_lang_1.useLang)();
  var canAdmin = (0, current_user_can_1.currentUserCanAdmin)();
  var definition = (0, use_entity_definition_named_1.useEntityDefinitionNamed)(entityTypeName);
  var client = (0, client_1.useApolloClient)();
  var page = Math.max(Math.min(props.page, fieldSets.length - 1), 0);
  // // store a sub-set of the field info
  var _a = __read((0, react_1.useState)({
      valid: true,
      message: '',
      submitting: false
    }), 2),
    state = _a[0],
    setState = _a[1];
  React.useEffect(function () {
    if (!!submitError) {
      setState({
        submitting: false
      });
    }
  }, [submitError]);
  var _b = (0, use_form_1.useForm)().supportedFieldNames,
    supportedFieldNames = _b === void 0 ? [] : _b;
  var fields = React.useMemo(function () {
    return (0, lodash_1.filter)(props.fields.map(function (field) {
      return __assign(__assign({}, field), {
        disabled: field.disabled || state.submitting,
        isAvailable: field.isAvailable || function (s) {
          return true;
        }
      });
    }), function (field) {
      return !supportedFieldNames.length || (0, lodash_1.includes)(__spreadArray(__spreadArray([], __read(supportedFieldNames), false), ["name", "id"], false), field.name);
    });
  }, [props.fields, supportedFieldNames]);
  var fieldDictionary = (0, lodash_1.keyBy)(fields, 'name');
  var appLayout = (0, use_app_layout_1.useAppLayout)();
  var visibleFields = fields.filter(function (field) {
    return !field.hidden;
  });
  var fieldsBySet = (0, react_1.useMemo)(function () {
    return (0, lodash_1.groupBy)(visibleFields, function (field) {
      return field.fieldSet || "overview";
    });
  }, [fields]);
  var sets = (0, react_1.useMemo)(function () {
    return (0, lodash_1.filter)(fieldSets.map(function (fieldSet) {
      var fields = fieldsBySet[fieldSet.name] || [];
      if (fieldSet.name === 'admin' && !canAdmin) {
        return null;
      }
      return fields.length ? __assign(__assign({}, fieldSet), {
        fields: fields
      }) : null;
    }));
  }, [fields]);
  var progressItems = paginate ? sets.map(function (fieldSet, index) {
    var status = 'none';
    if (index === page) {
      status = 'current';
    }
    ;
    var errorField = (0, lodash_1.find)(fieldSet.fields, function (_a) {
      var name = _a.name;
      return !!(fieldState[name] && fieldState[name].valid === false); // this condition must be EXACTLY false, as it begins falsy (undefined)
    });
    if (errorField) {
      status = index === page ? 'current-error' : 'error';
    } else {
      // if (index < page || !isCreate) {
      //   status = 'complete';
      // }
    }
    return {
      key: fieldSet.name,
      label: t(fieldSet.label || (0, lodash_1.startCase)(fieldSet.name)),
      status: status
    };
  }) : [];
  React.useLayoutEffect(function () {
    if (window !== undefined && window.scrollTo) {
      window.scrollTo(0, 0);
    }
    ;
  }, [page]);
  var handleBlur = function (_a) {
    var name = _a.name,
      value = _a.value,
      _b = _a.options,
      options = _b === void 0 ? {} : _b,
      _c = _a.metadata,
      metadata = _c === void 0 ? {} : _c;
    var field = fieldDictionary[name];
    if (field.onBlur) {
      field.onBlur({
        name: name,
        value: value,
        onChange: onChange,
        onNameBlur: onNameBlur,
        fieldState: fieldState,
        client: client
      });
    }
  };
  var handleChangeStatus = function (value) {
    handleChange({
      name: 'publishStatus',
      value: value,
      client: client,
      fieldState: fieldState
    });
  };
  var handleChange = function (_a) {
    var name = _a.name,
      value = _a.value,
      _b = _a.options,
      options = _b === void 0 ? {} : _b,
      _c = _a.metadata,
      metadata = _c === void 0 ? {} : _c;
    var field = fieldDictionary[name];
    if (name === 'publishStatus') {
      props.onChange((0, immer_1.default)(fieldState, function (draft) {
        draft.publishStatus = {
          value: value
        };
      }));
      return;
    }
    if (!field) {
      console.warn("Form received a change event for field '".concat(name, "' which doesn't exist in the form. Skipping."));
      return;
    }
    if (field.onChange) {
      field.onChange(field);
    }
    var stateValue = (0, lodash_1.isFunction)(value) ? value() : value;
    // update form field values
    // update form validity, focus, reason
    var finalFieldState = __assign(__assign({}, fieldState), (0, lodash_1.get)(options, 'extraFieldValues', {}));
    var newFields = (0, immer_1.default)(finalFieldState, function (draft) {
      draft[name] = draft[name] || {};
      draft[name].value = value;
      // assume the new value is a valid value until the next attempted submit
      draft[name].focus = false;
      draft[name].metadata = __assign(__assign({}, draft[name].metadata || {}), metadata || {});
      if (stateValue) {
        draft[name].valid = true;
        setState(__assign(__assign({}, state), {
          valid: true
        }));
      }
      (0, lodash_1.each)(fieldDictionary, function (field, fieldName) {
        draft[fieldName] = draft[fieldName] || {};
        draft[fieldName].focus = false;
        draft[fieldName].reason = null;
      });
    });
    props.onChange(newFields);
  };
  var submitting = state.submitting,
    message = state.message;
  var attrs = netlify ? {
    'data-netlify': true,
    'netlify-honeypot': honeypotName
  } : {};
  var ControlsRenderer = controlsRenderer;
  // if we're displaying in pages, just render the current set 
  var setsToRender = paginate && page < sets.length ? [sets[page]] : sets;
  var showInvalidState = function (validatedFields) {
    // prepare message. Filtering out those which do not have meta labels avoids any sub-form fields which do not have these generated 
    var invalidFields = (0, lodash_1.filter)(validatedFields, function (field) {
      return !field.valid && Boolean(field.metadata && field.metadata.label);
    });
    var message = (0, sprintf_js_1.sprintf)(t('Please provide a valid value for %s and try again.'), [invalidFields.map(function (f) {
      return "<b>".concat(f.metadata && f.metadata.label, "</b>");
    }).join(', ')]);
    setState(__assign(__assign({}, state), {
      message: message,
      valid: false,
      submitting: false
    }));
  };
  var handleSubmit = function (event) {
    return __awaiter(void 0, void 0, void 0, function () {
      var validatedFields, fieldValues, info, err_1;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            event.preventDefault();
            validatedFields = validate(fieldState, fieldDictionary, fieldHasValue);
            if (!!(0, lodash_1.some)(filterUnknown(validatedFields, fieldDictionary), function (field) {
              return !field.valid;
            })) return [3 /*break*/, 5];
            _a.label = 1;
          case 1:
            _a.trys.push([1, 3,, 4]);
            setState({
              valid: true,
              submitting: true
            });
            fieldValues = (0, form_field_values_1.formFieldValues)(validatedFields);
            info = {
              fieldValues: fieldValues,
              fieldState: validatedFields,
              mutationInput: (0, submit_mutation_input_1.submitMutationInput)(fieldValues)
            };
            // console.log("INFO FOR SUBMIT", info);
            return [4 /*yield*/, props.onSubmit(info)];
          case 2:
            // console.log("INFO FOR SUBMIT", info);
            _a.sent();
            setTimeout(function () {
              return setState({
                valid: true,
                submitting: false
              });
            }, 50);
            return [3 /*break*/, 4];
          case 3:
            err_1 = _a.sent();
            alert(err_1);
            return [3 /*break*/, 4];
          case 4:
            return [3 /*break*/, 6];
          case 5:
            props.onChange(validatedFields);
            showInvalidState(validatedFields);
            _a.label = 6;
          case 6:
            return [2 /*return*/];
        }
      });
    });
  };
  var doChangePage = function (success) {
    var currentSet = sets[page];
    var currentFieldNames = currentSet.fields.map(function (f) {
      return f.name;
    });
    var include = function (field) {
      return currentFieldNames.indexOf(field.name) !== -1;
    };
    var validatedFields = validate(fieldState, fieldDictionary, fieldHasValue, include);
    // console.log("VALIDATED FIELDS", validatedFields);
    // console.log(formFieldValues(validatedFields));
    var checkFields = (0, lodash_1.pickBy)(validatedFields, function (field, fieldName) {
      return currentFieldNames.indexOf(fieldName) !== -1;
    });
    if (!(0, lodash_1.some)(filterUnknown(checkFields, fieldDictionary), function (field) {
      return !field.valid;
    })) {
      var nextSet_1 = page < sets.length && sets[page + 1];
      setState(__assign(__assign({}, state), {
        valid: true
      }));
      var focused = (0, immer_1.default)(validatedFields, function (draft) {
        if (nextSet_1) {
          if (nextSet_1.fields.length) {
            var nextFieldName_1 = nextSet_1.fields[0].name;
            (0, lodash_1.each)(draft, function (f, name) {
              if (name === nextFieldName_1) {
                f.focus = true;
              }
            });
          }
        }
      });
      props.onChange(focused);
      success();
    } else {
      props.onChange(validatedFields);
      showInvalidState(checkFields);
    }
  };
  var handleNextPage = function () {
    doChangePage(onNextPage);
  };
  var handleChangePage = function (page) {
    doChangePage(function () {
      onChangePage(page);
    });
  };
  var handlePreviousPage = function () {
    setState(__assign(__assign({}, state), {
      valid: true
    }));
    onPreviousPage();
  };
  var hasPages = paginate && sets.length > 1;
  var body = loading ? React.createElement(My.LoadingLayout, {
    isModal: isModal
  }) : React.createElement(React.Fragment, null, React.createElement("input", {
    type: "hidden",
    name: "form-name",
    value: name
  }), head, (0, lodash_1.map)(setsToRender, function (fieldSet, fskey) {
    var FieldSetRenderer = fieldSet.renderer || fieldSetRenderer;
    var fieldProps = (0, lodash_1.keyBy)(fieldSet.fields, 'name');
    return React.createElement(FieldSetRenderer, {
      key: fskey,
      paginate: hasPages,
      formLabel: label,
      intro: fieldSet.intro,
      outro: fieldSet.outro
    }, (0, lodash_1.map)(fieldProps, function (field, fieldName) {
      var FieldRenderer = field.renderer || fieldRenderer;
      var currentFieldState = fieldState[field.name] || {};
      var valid = (0, lodash_1.isUndefined)(currentFieldState.valid) ? true : currentFieldState.valid;
      var stateProps = {
        valid: valid,
        loadingMessage: currentFieldState.loadingMessage,
        value: currentFieldState.value || '',
        defaultValue: currentFieldState.defaultValue || '',
        disabled: Boolean(field.disabled || currentFieldState.disabled),
        errorMessage: currentFieldState.reason === 'invalid' ? currentFieldState.errorMessage || '' : '',
        placeholder: valid ? field.placeholder : currentFieldState.errorMessage
      };
      /* --
        setup fields, ensuring that:
        1. fields have sensible defaults for valid, value, etc
        2. the current state of this field is included (...thisFieldState)
      */
      var fieldProp = __assign(__assign(__assign({
        labelRenderer: field.labelRenderer || labelRenderer,
        formName: name,
        formIndex: index
      }, field), stateProps), {
        /* merge metadata which is passed in to the field, but also may be changed by field state */
        metadata: __assign(__assign({}, field.metadata || {}), currentFieldState.metadata || {})
      });
      return field.isAvailable(fieldState) && React.createElement(FieldRenderer, {
        isInvisible: field.isInvisible,
        key: field.name,
        field: fieldProp
      }, field.render({
        onChange: function (_a) {
          var name = _a.name,
            value = _a.value,
            options = _a.options,
            metadata = _a.metadata;
          return handleChange({
            name: name,
            value: value,
            options: options,
            metadata: metadata,
            fieldState: fieldState,
            client: client
          });
        },
        onBlur: function (_a) {
          var name = _a.name,
            value = _a.value,
            options = _a.options,
            metadata = _a.metadata;
          return handleBlur({
            name: name,
            value: value,
            options: options,
            metadata: metadata,
            fieldState: fieldState,
            client: client
          });
        },
        field: fieldProp
      }));
    }));
  }));
  return React.createElement(form_state_context_1.FormStateProvider, {
    value: fieldState
  }, React.createElement(My.Form, __assign({
    isModal: isModal,
    onSubmit: handleSubmit,
    name: name,
    method: "post"
  }, attrs, {
    className: className
  }), React.createElement(ContextStyle, null), React.createElement(global_style_1.GlobalStyle, null), React.createElement(My.Container, {
    isModal: isModal,
    className: className
  }, submitting && React.createElement(My.SubmittingOverlay, {
    isModal: isModal
  }, React.createElement(My.SubmittingLoader, {
    spinnerSize: 20
  }, t('Saving. Please wait'))), React.createElement(My.DummyHeader, {
    isModal: isModal,
    icon: icon,
    onCancel: onCancel,
    onChangePage: handleChangePage,
    submitting: submitting,
    progressItems: progressItems,
    title: label,
    subTitle: subLabel,
    badge: badge
  }, labelElement), React.createElement(My.Header, {
    className: "handle",
    isModal: isModal,
    icon: icon,
    onCancel: onCancel,
    onChangePage: handleChangePage,
    submitting: submitting,
    progressItems: progressItems,
    title: label,
    subTitle: subLabel,
    badge: badge,
    _width: appLayout.availableWidth
  }, labelElement), React.createElement(My.BodyContainer, {
    isModal: isModal,
    fillModal: fillModal
  }, React.createElement(My.Body, {
    lockScroll: submitting || hasActiveModal,
    isModal: isModal,
    _loading: loading,
    hasProgress: hasPages,
    hasError: false
  }, React.createElement(My.BodyLayout, null, React.createElement(My.BodyConstrain, {
    bufferAtEnd: !loading && props.bufferAtEnd,
    maxWidth: loading ? null : maxWidth
  }, body)))), React.createElement(My.Footer, {
    _width: appLayout.availableWidth,
    isModal: isModal,
    hasError: state.valid === false
  }, React.createElement(My.FooterStripes, {
    showStripes: showStripes
  }), (state.valid === false || !!submitError) && !submitting && React.createElement(My.ErrorMessageContainer, null, React.createElement(My.ErrorMessage, {
    iconSize: 22
  }, React.createElement(html_1.HTML, {
    text: message || submitError
  }))), React.createElement(My.FooterLayout, {
    className: "handle"
  }, React.createElement(My.FooterBody, null, React.createElement(ControlsRenderer, {
    isCreate: isCreate,
    onDelete: onDelete,
    showDeleteButton: showDeleteButton,
    startControls: !isModal && startControls,
    entityTypeName: entityTypeName,
    submitting: submitting,
    statusValue: statusValue,
    onChangeStatus: handleChangeStatus,
    paginate: hasPages
  }))))), children));
};
exports.Form = Form;
exports.Form.defaultProps = exports.FormDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60, templateObject_61, templateObject_62, templateObject_63, templateObject_64, templateObject_65, templateObject_66, templateObject_67, templateObject_68, templateObject_69, templateObject_70, templateObject_71, templateObject_72, templateObject_73, templateObject_74, templateObject_75, templateObject_76, templateObject_77, templateObject_78, templateObject_79, templateObject_80, templateObject_81, templateObject_82;